/**
 * Driver Deliveries (long distance): which jobs can be handed to a driver, and
 * how the ETA is written. Mirrors DRIVER_ASSIGNABLE / fmtTime in the prototype.
 */

/** Statuses a job can be dragged out of into Driver Deliveries. */
export const DRIVER_ASSIGNABLE = [
  "ld-in-transit",
  "ld-window-ending",
  "ld-warehouse-received",
  "ld-sit-confirmed",
];

export const DRIVER_STATUS = "ld-driver-delivery";

/** "14:30" -> "2:30 PM"; "" when there is no time. */
export const fmtTime = (t) => {
  if (!t) return "";
  const [hours, minutes] = String(t).split(":");
  const h = parseInt(hours, 10);
  if (Number.isNaN(h)) return "";
  return `${h % 12 || 12}:${minutes || "00"} ${h >= 12 ? "PM" : "AM"}`;
};

export const isDriverAssignable = (job) => !!job && DRIVER_ASSIGNABLE.includes(job.status);
